import { store } from "Redux/store";
import axios from "axios";

/**
 * Fonction qui permet de modifier des données à l'API sans passer par un Hook react
 * @param {String} url - Url vers laquelle faire la requête
 * @param {*} payload - Données POST à envoyer
 * @returns {Object} - Réponse de l'API
 */
export const fetchPost = async (
  url,
  payload,
  fullUrl = false,
  noToken = false
) => {
  let data = null;
  let error = null;
  const token = noToken ? null : store.getState().auth.token;

  const finalUrl = fullUrl
    ? url
    : `${process.env.REACT_APP_BASE_URL_API}${url}`;

  await axios
    .post(finalUrl, payload, {
      headers: token
        ? {
            accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          }
        : {
            accept: "application/json",
          },
    })
    .then((response) => {
      data = response.data;
    })
    .catch((e) => (error = e));
  return { data, error };
};

/**
 * Fonction qui permet de modifier des données à l'API sans passer par un Hook react
 * @param {String} url - Url vers laquelle faire la requête
 * @param {*} payload - Données POST à envoyer
 * @returns {Object} - Réponse de l'API
 */
export const fetchPut = async (url, payload) => {
  let data = null;
  let error = null;
  const token = store.getState().auth.token;

  await axios
    .put(`${process.env.REACT_APP_BASE_URL_API}${url}`, payload, {
      headers: token
        ? {
            accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          }
        : {
            accept: "application/json",
          },
    })
    .then((response) => {
      data = response.data;
    })
    .catch((e) => (error = e));
  return { data, error };
};

/**
 * Fonction qui permet de récupérer des données à l'API sans passer par un Hook react
 * @param {String} url - Url vers laquelle faire la requête
 * @param {*} payload - Données POST à envoyer
 * @returns {Object} - Réponse de l'API
 */
export const fetchGet = async (url) => {
  let data = null;
  let error = null;
  const token = store.getState().auth.token;

  await axios
    .get(`${process.env.REACT_APP_BASE_URL_API}${url}`, {
      headers: token
        ? {
            accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          }
        : {
            accept: "application/json",
          },
    })
    .then((response) => {
      data = response.data;
    })
    .catch((e) => (error = e));
  return { data, error };
};
